export async function getCsrfToken(): Promise<string> {
  if (typeof document === 'undefined') return ''

  const existing = readCookie('csrf_token')
  if (existing) return existing

  try {
    const response = await fetch('/api/auth/csrf', { credentials: 'include' })
    if (!response.ok) return ''
    const data = await response.json()
    const token = typeof data?.token === 'string' ? data.token : ''
    return token || readCookie('csrf_token')
  } catch {
    return ''
  }
}

export async function getCsrfHeaders(): Promise<Record<string, string>> {
  const token = await getCsrfToken()
  if (!token) return {}
  return { 'X-CSRF-Token': token }
}

function readCookie(name: string): string {
  if (typeof document === 'undefined') return ''
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : ''
}
